import axios from 'axios';

const configuredApiUrl = process.env.REACT_APP_API_URL;
if (!configuredApiUrl) {
  throw new Error('REACT_APP_API_URL must be configured before starting the admin portal.');
}

const API_BASE_URL = configuredApiUrl;

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle token refresh on 401
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      // Try to refresh token
      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        try {
          const response = await axios.post(`${API_BASE_URL}/auth/refresh`, {
            refresh_token: refreshToken,
          });
          
          const { access_token } = response.data;
          localStorage.setItem('access_token', access_token);
          originalRequest.headers.Authorization = `Bearer ${access_token}`;
          
          return api(originalRequest);
        } catch (refreshError) {
          // Refresh failed, logout
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('user');
          window.location.href = '/login';
          return Promise.reject(refreshError);
        }
      } else {
        // No refresh token, logout
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    
    // In production the backend gates every admin route on the account having
    // 2FA enabled and answers 2FA_REQUIRED until it does. Without this redirect
    // the portal shows a wall of failures with no route to fixing them. Outside
    // production the backend never sends this code, so the branch is inert.
    if (error.response?.status === 403) {
      const body = error.response.data;
      const code = body?.error_code || body?.detail?.error_code;
      if (code === '2FA_REQUIRED' && window.location.pathname !== '/setup-2fa') {
        window.location.href = '/setup-2fa';
      }
    }

    return Promise.reject(error);
  }
);

export default api;
